import { RepositoryFactory } from "@/Apicall/RepositoryFactory";
const subcategory = RepositoryFactory.get("portfolioSubcategory");

export default {
  create({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await subcategory.create(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  get({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await subcategory.get(payload);
        commit("SET_SUBCATEGORY", data.data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  update({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await subcategory.update(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  delete({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await subcategory.delete(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
